module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "选择素材",
      "visible": _vm.showDialog,
      "close-on-click-modal": false,
      "before-close": _vm.cancelAction
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "appmsg_list media_dialog"
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('div', {
      staticClass: "appmsg_col",
      class: {
        'checked': _vm.i === index
      },
      on: {
        "click": function($event) {
          return _vm.selcteItem(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "appmsg msg-item has-first-cover",
      class: {
        multi: item.content.news_item[1], single: !item.content.news_item[1]
      }
    }, [_c('div', {
      staticClass: "msg-content"
    }, [_c('div', {
      staticClass: "msg-info"
    }, [_c('span', [_vm._v("更新于 " + _vm._s(_vm._f("datetime")(item.update_time)))])]), _vm._v(" "), _c('div', {
      staticClass: "sub-msg-item",
      class: {
        coverMsgItem: item.content.news_item[1]
      }
    }, [_c('h4', {
      staticClass: "msg-title"
    }, [_c('a', [_vm._v(_vm._s(item.content.news_item[0].title))])]), _vm._v(" "), _c('div', {
      staticClass: "msg-thumb-wrap",
      style: ({
        backgroundImage: 'url(' + _vm.wximageurl + item.content.news_item[0].thumb_url + ')'
      })
    }), _vm._v(" "), _c('a', {
      staticClass: "edit-mask preview-mask",
      attrs: {
        "href": item.content.news_item[0].url
      }
    }, [_c('div', {
      staticClass: "edit-mask-content"
    }, [_vm._v("\n                    预览文章\n                  ")])])]), _vm._v(" "), (!item.content.news_item[1]) ? _c('p', {
      staticClass: "msg-desc"
    }, [_vm._v(_vm._s(item.content.news_item[0].digest))]) : _vm._e(), _vm._v(" "), _vm._l((item.content.news_item.length - 1), function(n) {
      return _c('div', [(item.content.news_item[1]) ? _c('div', {
        staticClass: "article-msg-item has-cover clearfix"
      }, [_c('div', {
        staticClass: "msg-thumb-wrap",
        style: ({
          backgroundImage: 'url(' + _vm.wximageurl + item.content.news_item[n].thumb_url + ')'
        })
      }), _vm._v(" "), _c('h4', {
        staticClass: "msg-title"
      }, [_c('a', [_vm._v(_vm._s(item.content.news_item[n].title))])]), _vm._v(" "), _c('a', {
        staticClass: "edit-mask preview-mask",
        attrs: {
          "href": item.content.news_item[n].url
        }
      }, [_c('div', {
        staticClass: "edit-mask-content"
      }, [_vm._v("\n                      预览文章\n                    ")])])]) : _vm._e()])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "preview-mask-wrap appmsg_mask"
    }, [_c('i', {
      staticClass: "el-icon-check"
    })])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAction
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveAction
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2bb61bfd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bb61bfd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aterialanagementselect/index.vue
// module id = 2573
// module chunks = 0